// removed by extract-text-webpack-plugin
module.exports = {"black-nudge":"black-nudge__3y4p3","black-close":"black-close__3Zn8c","closing-icon":"closing-icon__1gIw6","black-logo":"black-logo__3oFsD","wrapper":"wrapper__3kyKQ","black-title":"black-title__3Gl7e","inline-block":"inline-block__1rxQz","font--10":"font--10__1-jxS","black-btn":"black-btn__ubUkQ","btn-topCTA":"btn-topCTA__32xXo"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/blackNudge.scss
// module id = 1110
// module chunks = 68